import React, { useCallback, useState } from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { connect } from 'react-redux';
import { unwrapResult } from '@reduxjs/toolkit';
import PropTypes from 'prop-types';

import { cxHelpers } from 'util/className';
import * as flashNotice from 'util/flashNotice';
import { toI18n } from 'util/i18n';
const { cx, cxEl } = cxHelpers('InfoBannerButtons');

import Icon from 'fe-design-base/atoms/Icon';
import Text from 'fe-design-base/atoms/Text';
import Button from 'fe-design-base/molecules/Button';

import { sendPacket } from 'features/employeeOnboarding/documents/slices';

import Box from 'components/Box';

const InfoBannerButtons = ({
  user,
  form,
  onClickAddFormDetails,
  onSendPacket,
}) => {
  const [isPrimary, setIsPrimary] = useState(true);
  const [isLoadingSendPacket, setIsLoadingSendPacket] = useState(false);

  const handleOnClickUpdateForm = useCallback(() => {
    setIsPrimary(false);
  }, []);

  const textI18n = useCallback(() => {
    if (form.get('is_blocking')) {
      return 'team.employee_profile.tax_information.info_content.not_on_file_mandatory';
    }
    return 'team.employee_profile.tax_information.info_content.not_on_file';
  }, [form]);

  const handleOnClickSendPacket = useCallback(() => {
    setIsLoadingSendPacket(true);
    onSendPacket({
      userId: user.get('id'),
    })
      .then(unwrapResult)
      .then(result => {
        if (result.missing_user_data) {
          flashNotice.error(
            toI18n(
              'employee_documents.packet_status.missing_contact_info_notice'
            )
          );
          return;
        } else if (result.no_job_at_current_location) {
          return flashNotice.error(result.errors);
        }
        flashNotice.success(
          toI18n('employee_documents.packet_status.sent_success')
        );
      })
      .finally(() => {
        setIsLoadingSendPacket(false);
      });
  }, [user, onSendPacket]);

  const showPrimaryUpdateButton = isPrimary && form.get('is_submitted');

  return (
    <>
      {!form.get('is_submitted') && (
        <Box>
          <Box vcenter hcenter mb={16}>
            <Icon iconName="Document" size="large" color="mono500" />
          </Box>
          <Box vcenter hcenter mb={16}>
            <Text i18n={textI18n()} />
          </Box>
        </Box>
      )}
      <Box row hcenter className={cx()}>
        {showPrimaryUpdateButton && (
          <Box className={cxEl('update-form')}>
            <Button
              size="medium"
              variant="secondary"
              onClick={handleOnClickUpdateForm}
            >
              <Text
                i18n="team.employee_profile.tax_information.update"
                i18nProps={{ form: form.get('description') }}
              />
            </Button>
          </Box>
        )}
        {(!isPrimary || !form.get('is_submitted')) && (
          <>
            <Box>
              <Button
                size="medium"
                variant="tertiary"
                onClick={onClickAddFormDetails}
              >
                <Text i18n="team.employee_profile.tax_information.add_form_details" />
              </Button>
            </Box>

            {user.get('show_send_packet_button') && (
              <Box ml16>
                <Button
                  className={cxEl('send-packet')}
                  size="medium"
                  variant="secondary"
                  startIcon="Email"
                  onClick={handleOnClickSendPacket}
                  isLoading={isLoadingSendPacket}
                >
                  <Text
                    i18n="team.employee_profile.tax_information.send_packet"
                    i18nProps={{ name: user.get('first_name') }}
                  />
                </Button>
              </Box>
            )}
          </>
        )}
      </Box>
    </>
  );
};

InfoBannerButtons.propTypes = {
  user: ImmutablePropTypes.map.isRequired,
  form: ImmutablePropTypes.map.isRequired,
  onSendPacket: PropTypes.func.isRequired,
  onClickAddFormDetails: PropTypes.func.isRequired,
};
export default connect(() => ({}), {
  onSendPacket: sendPacket,
})(InfoBannerButtons);
